module.exports = __webpack_public_path__ + "img/insurance-1.28c34a4.svg";